import './UnmappedLabel.scss';

import { IconAlertWarningOutlined } from '@hulu-react-style-components/icons';
import { bem } from 'mission-control-common-components';
import React from 'react';

const [block, element] = bem('unmapped-label');

type UnmappedLabelProps = {
  label: string;
  adCount: number;
};

const UnmappedLabel = ({ label, adCount }: UnmappedLabelProps): React.JSX.Element => {
  return (
    <span className={block()}>
      <IconAlertWarningOutlined className={element('icon')} />
      <span className={element('text')}>{label}</span>
      <span className={element('count')}>{adCount}</span>
    </span>
  );
};

export default UnmappedLabel;
